import { motion } from "framer-motion";

const HUG = "/couple/hug.png";
const HANDS = "/couple/holding_hands.png";

/**
 * Cute animated versions of Nits & Eva placed at deliberate spots.
 * Each accent floats/bobs gently to feel alive without distracting from the copy.
 */
const ACCENTS = [
  // hero — top right, peeking
  {
    src: HUG,
    className:
      "hidden md:block absolute top-8 right-6 lg:right-16 w-28 lg:w-36 rotate-[6deg] pointer-events-none",
    float: { y: [0, -8, 0], rotate: [6, 3, 6] },
    duration: 6,
    alt: "us hugging",
  },
  // hero — bottom left, small
  {
    src: HANDS,
    className:
      "hidden lg:block absolute bottom-16 left-8 w-24 -rotate-[8deg] pointer-events-none opacity-90",
    float: { y: [0, -6, 0], rotate: [-8, -11, -8] },
    duration: 7.5,
    alt: "us holding hands",
  },
  // between letter and promises
  {
    src: HANDS,
    className:
      "block absolute top-[105%] right-4 sm:right-10 w-24 sm:w-32 rotate-[5deg] pointer-events-none",
    float: { y: [0, -7, 0] },
    duration: 6.5,
    alt: "us together",
  },
  // near reasons gallery
  {
    src: HUG,
    className:
      "hidden sm:block absolute -top-6 left-4 sm:left-8 w-20 sm:w-24 -rotate-[10deg] pointer-events-none",
    float: { y: [0, -5, 0], rotate: [-10, -6, -10] },
    duration: 5.5,
    alt: "us hugging",
  },
  // near forgiveness
  {
    src: HUG,
    className:
      "hidden md:block absolute top-10 right-8 lg:right-24 w-24 lg:w-28 rotate-[9deg] pointer-events-none",
    float: { y: [0, -6, 0] },
    duration: 6,
    alt: "us hugging",
  },
  // near virtual hug
  {
    src: HANDS,
    className:
      "hidden md:block absolute bottom-10 left-6 lg:left-24 w-24 lg:w-32 -rotate-[6deg] pointer-events-none",
    float: { y: [0, -8, 0], rotate: [-6, -3, -6] },
    duration: 7,
    alt: "us together",
  },
  // near signoff — a bigger centerpiece
  {
    src: HUG,
    className:
      "block absolute -top-24 left-1/2 -translate-x-1/2 w-40 sm:w-48 pointer-events-none",
    float: { y: [0, -10, 0], rotate: [-2, 2, -2] },
    duration: 5,
    alt: "us hugging",
  },
];

export const CoupleAccent = ({
  src,
  className,
  float,
  duration,
  alt,
  delay = 0,
}) => (
  <motion.img
    src={src}
    alt={alt}
    className={className}
    initial={{ opacity: 0, scale: 0.9 }}
    animate={{
      opacity: 1,
      scale: 1,
      ...(float || {}),
    }}
    transition={{
      opacity: { duration: 0.9, delay },
      scale: { duration: 0.9, delay },
      y: float?.y
        ? { duration, repeat: Infinity, ease: "easeInOut", delay: delay + 0.3 }
        : undefined,
      rotate: float?.rotate
        ? { duration, repeat: Infinity, ease: "easeInOut", delay: delay + 0.3 }
        : undefined,
    }}
    style={{ filter: "drop-shadow(0 12px 24px rgba(194, 128, 128, 0.22))" }}
    aria-hidden="true"
    data-testid="couple-accent"
  />
);

export const CoupleAccents = { ACCENTS, HUG, HANDS };
export default CoupleAccent;
